import { render, staticRenderFns } from "./pageDivFooter.vue?vue&type=template&id=9b951a3c&"
import script from "./pageDivFooter.vue?vue&type=script&lang=js&"
export * from "./pageDivFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageDivFooter.vue?vue&type=style&index=0&id=9b951a3c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports